import { render, staticRenderFns } from "./FrogetPass.vue?vue&type=template&id=41d32dcc"
import script from "./FrogetPass.vue?vue&type=script&lang=js"
export * from "./FrogetPass.vue?vue&type=script&lang=js"
import style0 from "./FrogetPass.vue?vue&type=style&index=0&id=41d32dcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports